import {gql} from '@apollo/client';

export const MUTATION_CREATE_PAYMENT = gql`
mutation createPayment($data: PaymentInput!) {
    createPayment(data: $data) {
        documentId
        paymentUrl
        paymentStatus
    }
}`

export const QUERY_PAYMENT = gql`

    query payment($documentId: ID!) {
    payment(documentId: $documentId) {
        documentId
        paymentStatus
        paymentUrl
        order {
            documentId
            order_status
        }
    }
}`

